import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/index.css'

Vue.use(ElementUI)
Vue.config.productionTip = false

window.addEventListener('jjzx:session-expired', () => { store.commit('session', null) })

window.addEventListener('jjzx:password-change-required', () => {
  store.commit('requirePasswordChange')
  if (router.currentRoute.path !== '/change-password') router.replace('/change-password')
})

router.beforeEach(async (to, from, next) => {
  if (to.path !== '/login' && !store.state.token) return next('/login')
  if (store.state.token) {
    try { await store.dispatch('refreshProfile') } catch (e) { await store.dispatch('logout'); return next('/login') }
  }
  const required = store.state.user && store.state.user.password_change_required
  if (required && to.path !== '/change-password') return next('/change-password')
  if (!required && store.state.token && (to.path === '/login' || to.path === '/change-password')) return next('/')
  if (to.meta && to.meta.permission && !store.getters.can(to.meta.permission)) return next('/403')
  next()
})

new Vue({ router, store, render: h => h(App) }).$mount('#app')
